// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1vwoE","dragIcon":"SortableItem_dragIcon__n4X0p","disabled":"SortableItem_disabled__Jw6da"};